module.exports = __webpack_public_path__ + "static/img/news-20230424.c6a9b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20230424.png
// module id = KD8P
// module chunks = 0